import { Grid, TextInput } from "@mantine/core";
import { FormikProps } from "formik";
import { FC } from "react";

interface BankAccountFormFieldsProps {
  formik: FormikProps<any>;
  isCreateMode?: boolean;
}

const spanHalf = { base: 12, md: 6 };

const BankAccountFormFields: FC<BankAccountFormFieldsProps> = ({
  formik,
  isCreateMode = false,
}) => {
  const getFieldError = (field: string) =>
    formik.touched[field] && formik.errors[field]
      ? (formik.errors[field] as string)
      : null;

  return (
    <Grid>
      {isCreateMode && (
        <Grid.Col span={spanHalf}>
          <TextInput
            label="Mã tài khoản"
            placeholder="VD: TK-001"
            {...formik.getFieldProps("code")}
            error={getFieldError("code")}
          />
        </Grid.Col>
      )}

      <Grid.Col span={spanHalf}>
        <TextInput
          label="Tên ngân hàng"
          placeholder="VD: Vietcombank"
          withAsterisk
          {...formik.getFieldProps("bankName")}
          error={getFieldError("bankName")}
        />
      </Grid.Col>

      <Grid.Col span={spanHalf}>
        <TextInput
          label="Số tài khoản"
          placeholder="Nhập số tài khoản"
          withAsterisk
          {...formik.getFieldProps("accountNumber")}
          error={getFieldError("accountNumber")}
        />
      </Grid.Col>

      <Grid.Col span={spanHalf}>
        <TextInput
          label="Chủ tài khoản"
          placeholder="Nhập tên chủ tài khoản"
          withAsterisk
          {...formik.getFieldProps("accountHolder")}
          error={getFieldError("accountHolder")}
        />
      </Grid.Col>
    </Grid>
  );
};

export default BankAccountFormFields;
